import React from "react"
import type { PageProps } from "gatsby"

import SEO from "~components/shared/seo"
import { ListingContent } from "~components/pages/listing/listing-content"
import type { PublicListingFieldsFragment } from "~graphql/generated/graphql"
import { EntityType } from "~utils/event-tracking/event-tracking-constants"
import { useTrackSelectContent } from "~utils/use-track-select-content"
import { useTrackListingVisitedEvent } from "~utils/event-hooks"
import { CurrentListingProvider } from "~components/providers/current-listing-provider"

interface Props {
    readonly listing: PublicListingFieldsFragment
}

export default function Listing({
    pageContext: { listing },
}: PageProps<object, Props>) {
    useTrackSelectContent({
        entityId: listing.id,
        entityType: EntityType.LISTINGS,
    })
    useTrackListingVisitedEvent(listing.id)

    return (
        <CurrentListingProvider listing={listing}>
            <SEO
                title={
                    `${listing.title} in ${listing.location?.city}, ${listing.location?.state}` ||
                    `Book with Mallard Bay`
                }
                image={listing.photos[0]?.url}
                description={`Book ${listing.title} for your next outdoors adventures on Mallard Bay`}
            />
            <ListingContent listing={listing} />
        </CurrentListingProvider>
    )
}
